import { gql } from '@apollo/client';

export const getLocalidades = gql`
query getLocalidades{
    localidades (provincias:$provincias, tipo:$tipoBuscador)
    @rest(type: "Localidad[]", path: "/{args.tipo}/localidadesvigentes"){
        codigo
        descripcion
    }
}`
